import { render, staticRenderFns } from "./DriverInformation.vue?vue&type=template&id=1abb148e&scoped=true&"
import script from "./DriverInformation.vue?vue&type=script&lang=js&"
export * from "./DriverInformation.vue?vue&type=script&lang=js&"
import style0 from "./DriverInformation.vue?vue&type=style&index=0&id=1abb148e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb148e",
  null
  
)

export default component.exports